import { IStandardAutocomplete } from "../../_common/interface/autocomplete/iStandardAutocomplete";
import { fileUploadTypeService } from "../../_services/fileUploadType.service";
import StandardAutoComplete from "./standard.autocomplete";

interface IStandardExtAutocomplete extends IStandardAutocomplete {
}

export const FileUploadTypeAutoComplete = (params: IStandardExtAutocomplete) => {

    return (
        <StandardAutoComplete
            {...params}
            itemsLoader={fileUploadTypeService.getDropdown}
            label={"File Upload Type"} />
    );
}